import styledImport from '@emotion/styled';
import { Medium, Regular, SemiBold } from '../../apps/styles/common-style';

const styled = (styledImport as any).default || styledImport;

export const KnowledgeCneterStyle = styled('div')({
  ".filter-div-scroll": {
    overflowY: "auto",
    maxHeight: "100%",
    overflowX: "hidden",
    width: "418px"
  },
  ".sidemargin": {
    margin: "20px 24px 0px 24px",
    height: "inherit",
  },
  ".headerSection": {
    display: "flex",
    alignItems: "center"
  },
  ".glossaryTitle": {
    color: "#2d2d39",
    wordBreak: "keep-all",
    fontFamily: Medium,
    fontSize: "28px",
    lineHeight: "32px",
    marginTop: "20px",
    letterSpacing: "0.2px"
  },
  ".h-3-title-filter": {
    color: "#2d2d39",
    fontFamily: SemiBold,
    fontSize: "22px",
    display: "flex",
    alignItems: "center",
    marginLeft: '10px',
  },
  ".icon-left-filter:hover": {
    backgroundColor: "#d7dce1",
    color: "#2d2d2d",
    cursor: "pointer"
  },
  ".abyss-icon-material": {
    fill: "#2d2d2d"
  },
  ".MuiModal-backdrop": {
    backgroundColor: "rgba(117, 117, 136, 0.7)"
  },
  ".close-icon-style": {
    width: "40px",
    height: "40px",
    float: "left",
    verticalAlign: "top"
  },
  ".filter-text-react": {
    lineHeight: "40px",
    width: "314px",
    verticalAlign: "middle",
    paddingLeft: '2.25em',
  },
  ".icon-left-filter": {
    color: "#757588",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "2px",
    cursor: "pointer"
  },
  ".glossary-definition": {
    wordBreak: "keep-all",
    color: "#2d2d39",
    fontFamily: Medium,
    fontSize: "16px",
    letterSpacing: "0.2px",
    lineHeight: "22px",

    ".bullet": {
      listStyleType: "disc",
      marginLeft: "20px",
    },
    "::ng-deep ul": {
      listStyle: "disc",
      listStylePosition: "outside",
      marginLeft: "20px",
    },
    "::ng-deep ol": {
      listStyle: "decimal",
      listStylePosition: "inside",
      marginLeft: "20px"
    },
    ".glossary-formula": {
      color: "#2d2d39",
      fontFamily: SemiBold,
      fontSize: "16px",
      letterSpacing: "0.2px",
      lineHeight: "22px",
      marginTop: "32px",
      marginBottom: "8px"
    }
  },

  '.KC-sidenav': {
    wordBreak: 'keep-all',
    padding: '10px',
    width: '354px',
    height: '100%',
  },
  '.metric-border': {
    borderTop: '1px solid #e0e0e0',
    paddingTop: '23px',
  },
  '.metric-definition': {
    height: '100%',
    fontSize: '16px',
    fontFamily: SemiBold,
    letterSpacing: '0.2px',
    padding: '0 0 8px 0',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    cursor: 'pointer',
  },
  '.metric-definition-text': {
    fontSize: '16px',
    fontFamily: SemiBold,
    lineHeight: '22px',
    color: '#196ecf',
    display: 'flex',
    alignItems: 'flex-start',
  },
  '.metric-definition .right-arrow-text': {
    verticalAlign: 'middle',
    marginLeft: '10px',
    marginTop: '3px',
  },
  '.mat-icon': {
    '-webkit-user-select': 'none',
    userSelect: 'none',
    backgroundRepeat: 'no-repeat',
    display: 'inline-block',
    fill: 'currentColor',
    height: '24px',
    width: '24px',
    overflow: 'hidden',
  },
  '.metric-definition-greytext': {
    fontFamily: Medium,
    fontSize: '16px',
    color: '#757588',
    lineHeight: '22px',
    marginTop: '8px',
    marginBottom: '24px',
  },
})